<template lang="pug">
b-modal#editThemeColor(
  ref="editThemeColor"
  :title="$t('ui.combine.edit_color')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.theme_code')" disabled).mb-1
      DebounceInput(
        size="sm"
        ref="theme_code"
        required
        type="text"
        :dirty="$v.theme_code.$dirty"
        :error="$v.theme_code.$error"
        v-model.trim.lazy="$v.theme_code.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.theme_code" :name="$t('ui.theme_code')")
    b-form-group(:label="$t('ui.color')").mb-1
      DebounceInput(
        size="sm"
        ref="theme_color"
        required
        type="text"
        :dirty="$v.theme_color.$dirty"
        :error="$v.theme_color.$error"
        v-model.trim.lazy="$v.theme_color.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.theme_color" :name="$t('ui.color')")

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import config from "@/config";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    itemColor: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      theme_color: '',
      target_theme_color: '',
      theme_code: '',
    };
  },
  validations: {
    theme_color: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20),
      noSpace: function(value) {
        const regexp = /^\S*$/.test(value);
        return regexp
      }
    },
    theme_code: {
      required,
      minLength: minLength(2),
      // maxLength: maxLength(50)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editThemeColorUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          theme_code: this.theme_code,
          theme_color: this.target_theme_color,
          new_theme_color: this.theme_color
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "combine.edit_color", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.editThemeColor.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.editThemeColor.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = response.data.status;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.theme_color = "";
      this.theme_code = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.theme_code = this.itemColor.theme_code;
      this.target_theme_color = this.itemColor.theme_color;
      this.theme_color = this.itemColor.theme_color;
      this.$refs.theme_color.$el.focus();
    }
  }
};
</script>
